export default "__VITE_ASSET__DUfg0yaL__"